import createAction from '@wix/communities-blog-client-common/dist/src/services/create-action';

export const ADD_USER = 'user/ADD';
export const addUser = createAction(ADD_USER);
